import React, { Component } from "react";

import PropTypes from "prop-types";
import styled from "styled-components";
import { InputField } from "./../../../StyledComponents";

const MediaInputComponent = styled(InputField)`
	width: 50px;
	text-align: center;
	padding: 8px 10px;
`;

class MediaInput extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { quantity, updateMediaValue } = this.props;

		return (
			<div style={{ textAlign: "center" }}>
				<MediaInputComponent
					placeholder="0"
					value={quantity}
					onChange={e => {
						const { value } = e.target;
						const formatedValue = parseInt(value);
						if (value === "") {
							updateMediaValue("0");
						} else if (!isNaN(formatedValue)) {
							updateMediaValue(formatedValue + "");
						}
					}}
				/>
			</div>
		);
	}
}

MediaInput.propTypes = {
	updateMediaValue: PropTypes.func.isRequired,
	locationType: PropTypes.object.isRequired,
	statement: PropTypes.object.isRequired,
	type: PropTypes.string.isRequired,
	quantity: PropTypes.string,
};

export default MediaInput;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/MediaInput.js